import { Modal } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import { QueryStatus } from '@reduxjs/toolkit/query';
import React from 'react';

import EyeIcon from '@/assets/icons/eye-open.svg?react';
import { DocumentPreviewWidget } from '@/components/molecules/DocumentPreviewWidget';
import { useTranslator } from '@/hooks/useTranslator';
import { TransactionDocument } from '@/types/transaction';

interface Props {
  readonly documents?: readonly TransactionDocument[];
}

export const TransactionDocumentsList: React.FC<Props> = (props: Props): React.ReactElement => {
  const [previewUrl, setPreviewUrl] = React.useState<string | undefined>();

  const { documents } = props;
  const tr = useTranslator();

  const onPreview = React.useCallback((viewUrl?: string): VoidFunction => {
    return (): void => {
      setPreviewUrl(viewUrl);
    };
  }, []);

  const closePreview = React.useCallback((): void => {
    setPreviewUrl(undefined);
  }, []);

  if (!documents || documents.length === 0) {
    return <></>;
  }

  return (
    <Box>
      <Typography variant="h7">{tr('SUPPORTING_DOCUMENTATION')}</Typography>
      <Box mt={3}>
        {documents.map(
          (document: TransactionDocument): React.ReactElement => (
            <DocumentPreviewWidget
              key={document.id}
              size={document.size}
              name={document.name}
              icon={EyeIcon}
              error={null}
              status={QueryStatus.fulfilled}
              onIconClick={onPreview(document.viewUrl)}
            />
          ),
        )}
      </Box>
      <Modal open={!!previewUrl} onClose={closePreview}>
        <Box sx={styles.modalContent}>
          <embed src={previewUrl} width="100%" height="100%" />
        </Box>
      </Modal>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    height: '90vh',
  },
};
